module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAABCAQAAACr1TyxAAAAE0lEQVQI12Nk8GL4jQR/ofB+AwDIvQ4FH4UbtAAAAABJRU5ErkJggg=="